<div class="add-new-container" formWithErrors #form=formWithErrors>
  <app-form-field [control]="itemControl">
    <input (keydown.enter)="ajouterItem()" [formControl]="itemControl" class="form_input" type="text" #inputFocus/>
  </app-form-field>
  <button (click)="form.showErrors(); ajouterItem()"
          class="button-base grid-col-sm-1">
    <i class="icon icon-validate"></i>
    <span class="button-main_text">
          Ajouter
        </span>
  </button>
</div>
